import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { SyncProgress, JobInitiateResponse } from '@tailorcast/shared-types';

export function useSyncProgress() {
  return useQuery({
    queryKey: ['sync', 'status'],
    queryFn: () => api.get<SyncProgress>(COMMERCE.SYNC_STATUS),
    refetchInterval: (query) =>
      query.state.data?.status === 'running' || query.state.data?.status === 'pending'
        ? 2000
        : false,
  });
}

export function useTriggerSync() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<JobInitiateResponse>(COMMERCE.SYNC_START, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sync', 'status'] });
    },
  });
}
